import { defineComponent } from 'vue';
import MessageBoxWithIcon from '@common/layout/messageBox/MessageBoxWithIcon.vue';
import RequiredFields from '@common/layout/RequiredFields.vue';
import AffectedComponent from '../atoms/AffectedComponent.vue';
import AlarmSelected from '../atoms/AlarmSelected.vue';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
import Duration from '../atoms/Duration.vue';
import Reason from '../atoms/Reason.vue';
import { translator } from '~/zf/frontend/common/mixins';
import AlarmType from '../../../../../portlet/viiu/alarms/const/AlarmType';
export default defineComponent({
    name: 'CreateBody',
    compatConfig: {
        MODE: 3,
    },
    components: {
        RequiredFields,
        Reason,
        AffectedComponent,
        MessageBoxWithIcon,
        AlarmSelected,
        Duration,
    },
    mixins: [translator],
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:model-value'],
    data() {
        return {
            BootstrapVariant,
        };
    },
    computed: {
        shouldCascade() {
            const allowedAlarmTypeIds = [AlarmType.COMMUNICATION_LOSS, AlarmType.TOTAL_OUTAGE, AlarmType.MISPRODUCTION];
            return allowedAlarmTypeIds.includes(this.modelValue.alarmInformation.alarmTypeId);
        },
    },
    methods: {
        updateDuration(update) {
            this.$emit('update:model-value', { ...this.modelValue, start: update[0], end: update[1] });
        },
    },
});
